import AlbumSlideshowOnboardingModal, {
  ALBUM_SLIDESHOW_ONBOARDING_MODAL,
} from './modal';

export { ALBUM_SLIDESHOW_ONBOARDING_MODAL };

export default AlbumSlideshowOnboardingModal;
